/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ChallengePromotionItem } from './ChallengePromotionItem';
import {
    ChallengePromotionItemFromJSON,
    ChallengePromotionItemFromJSONTyped,
    ChallengePromotionItemToJSON,
    ChallengePromotionItemToJSONTyped,
} from './ChallengePromotionItem';

/**
 * Promotions section configuration.
 * @export
 * @interface ChallengePromotionsSectionConfig
 */
export interface ChallengePromotionsSectionConfig {
    /**
     * 
     * @type {string}
     * @memberof ChallengePromotionsSectionConfig
     */
    layout?: ChallengePromotionsSectionConfigLayoutEnum;
    /**
     * 
     * @type {Array<ChallengePromotionItem>}
     * @memberof ChallengePromotionsSectionConfig
     */
    promotions?: Array<ChallengePromotionItem>;
}


/**
 * @export
 */
export const ChallengePromotionsSectionConfigLayoutEnum = {
    _2Up: '2-up',
    _3Up: '3-up'
} as const;
export type ChallengePromotionsSectionConfigLayoutEnum = typeof ChallengePromotionsSectionConfigLayoutEnum[keyof typeof ChallengePromotionsSectionConfigLayoutEnum];


/**
 * Check if a given object implements the ChallengePromotionsSectionConfig interface.
 */
export function instanceOfChallengePromotionsSectionConfig(value: object): value is ChallengePromotionsSectionConfig {
    return true;
}

export function ChallengePromotionsSectionConfigFromJSON(json: any): ChallengePromotionsSectionConfig {
    return ChallengePromotionsSectionConfigFromJSONTyped(json, false);
}

export function ChallengePromotionsSectionConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChallengePromotionsSectionConfig {
    if (json == null) {
        return json;
    }
    return {
        
        'layout': json['layout'] == null ? undefined : json['layout'],
        'promotions': json['promotions'] == null ? undefined : ((json['promotions'] as Array<any>).map(ChallengePromotionItemFromJSON)),
    };
}

export function ChallengePromotionsSectionConfigToJSON(json: any): ChallengePromotionsSectionConfig {
    return ChallengePromotionsSectionConfigToJSONTyped(json, false);
}

export function ChallengePromotionsSectionConfigToJSONTyped(value?: ChallengePromotionsSectionConfig | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'layout': value['layout'],
        'promotions': value['promotions'] == null ? undefined : ((value['promotions'] as Array<any>).map(ChallengePromotionItemToJSON)),
    };
}

